const schema = () => ({
  type: "object",
  required: [],
  properties: {
    title: {
      type: "string",
      title: "عنوان",
    },
    state_id: {
      type: "string",
      title: "استان",
    },
    details: {
      type: "string",
      title: "توضیحات",
    },
  },
});

export default schema;
